(function($) {
    $.widget("ca.caAjaxTab", {
        options: {
            data: {},
            formWizard: {}
        },

        _create: function() {
            var formWizardOptions = {
                disableUIStyles: true,
                inDuration: 0,
                outDuration: 0,
                disableInputFields: false
            };
            $.extend(formWizardOptions, this.options.formWizard);

            var clickableWizard = this.element;

            /* Initialize Clickable Wizard */
            clickableWizard.formwizard(formWizardOptions);

            clickableWizard.find('.step').show();

            var self = this;
            clickableWizard.on('click', '.clickable-steps a', function(){
                self.selectTab(this);
            });
        },

        selectTab: function(element) {
            var clickableWizard = this.element;

            $element = $(element);
            var loadlink = $element.data('loadlink');

            var contentDiv = clickableWizard.find('#content');
            if (!contentDiv || !loadlink) {
                return;
            }

            clickableWizard.find('.step').removeClass("active");
            $element.parent().addClass('active');

            $.caPost(loadlink, this.options.data, function(response) {
                contentDiv.html(response);
            });
        }
    })
})(jQuery);
